import { useEffect, useState } from "react";
import { WifiOff, Wifi, RefreshCw } from "lucide-react";
import { getLastSync, onNetworkChange, isOffline } from "@/lib/offlineCache";

const fmt = (t) => new Date(t).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

// Bandeau « Hors ligne » + dernière synchronisation ; les écrans affichent les dernières données synchronisées.
export function OfflineBanner() {
  const [off, setOff] = useState(isOffline());
  const [last, setLast] = useState(getLastSync());
  useEffect(() => onNetworkChange((o) => { setOff(o); setLast(getLastSync()); }), []);
  if (!off) return null;
  return (
    <div data-testid="offline-banner" className="mx-4 mt-3 rounded-xl bg-orange-50 border border-orange-200 text-orange-900 px-3 py-2 text-sm flex items-center gap-2">
      <WifiOff className="w-4 h-4 shrink-0" />
      <div className="flex-1"><b>Hors connexion</b> — données de la dernière synchronisation{last ? ` : ${fmt(last)}` : ""}.</div>
      <button type="button" data-testid="offline-retry" onClick={() => window.location.reload()} aria-label="Réessayer"><RefreshCw className="w-4 h-4" /></button>
    </div>
  );
}

// Indicateur compact (connexion + dernière synchronisation) affiché dans « Documents à récupérer ».
export function SyncStatus() {
  const [off, setOff] = useState(isOffline());
  const [last, setLast] = useState(getLastSync());
  useEffect(() => {
    const t = setInterval(() => setLast(getLastSync()), 5000);
    const un = onNetworkChange((o) => { setOff(o); setLast(getLastSync()); });
    return () => { clearInterval(t); un(); };
  }, []);
  return (
    <div data-testid="sync-status" className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-2.5 py-1 ${off ? "bg-orange-50 text-orange-800" : "bg-emerald-50 text-emerald-800"}`}>
      {off ? <WifiOff className="w-3.5 h-3.5" /> : <Wifi className="w-3.5 h-3.5" />}
      <span data-testid="sync-status-label">{off ? "Hors connexion" : "En ligne"}</span>
      {last && <span className="font-normal" data-testid="sync-status-last">· synchronisé le {fmt(last)}</span>}
    </div>
  );
}
